/* EmptyState — single source of truth for "nothing here yet" panels. */
import React from "react";
import { P } from "../../shared/constants";
var E = React.createElement;

export default function EmptyState(props){
  return E("div", {
    role:"status",
    style:{padding:"32px 24px",textAlign:"center",borderRadius:12,
      background:P.bgS,border:"1.5px dashed "+P.bdr}
  },
    props.icon ? E("div",{"aria-hidden":"true",style:{marginBottom:8,
      display:"flex",justifyContent:"center",color:P.slateM}}, props.icon) : null,
    E("div",{style:{fontSize:14,fontWeight:700,color:P.slate,marginBottom:4}}, props.title),
    props.message ? E("div",{style:{fontSize:11,color:P.slateM,marginBottom:props.action?14:0,maxWidth:360,marginLeft:"auto",marginRight:"auto"}}, props.message) : null,
    props.action || null
  );
}
